import(/* webpackMode: "eager" */ "/usr/src/app/apps/hotpads-web-next/src/app/error.tsx");
